module.exports = __webpack_public_path__ + "static/img/peoples.5268f502.svg";